import { faEarthAmericas, faUser, faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface AuditSummaryProps {
  reviewer: string;
  auditDate: string;
  projectId: string;
  projectName: string;
}

const AuditSummary = (props: AuditSummaryProps) => {
  return (
    <>
      <div className="mb-4 mb-xl-7">
        <table className="lh-sm mb-4 mb-sm-0 mb-xl-4">
          <tbody>
            <tr>
              <td className="py-1" colSpan={2}>
                <div className="d-flex">
                  <FontAwesomeIcon icon={faEarthAmericas} className="me-2 text-body-tertiary fs-9" />
                  <h5 className="text-body">{props.projectName}</h5>
                </div>
              </td>
            </tr>
            <tr>
              <td className="align-top py-1">
                <div className="d-flex">
                  <FontAwesomeIcon icon={faUser} className="me-2 text-body-tertiary fs-9" />
                  <h5 className="text-body mb-0 text-nowrap">Reviewer :</h5>
                </div>
              </td>
              <td className="ps-1 py-1">
                <h5 className="text-body mb-0 text-nowrap">{props.reviewer}</h5>
              </td>
            </tr>
            <tr>
              <td className="align-top py-1">
                <div className="d-flex">
                  <FontAwesomeIcon icon={faCalendar} className="me-2 text-body-tertiary fs-9" />
                  <h5 className="text-body mb-0 text-nowrap">Audit Date : </h5>
                </div>
              </td>
              <td className="fw-bold ps-1 py-1 text-body-highlight">{props.auditDate}</td>
            </tr>
          </tbody>
        </table>
        <table className="lh-sm">
          <tbody>
            <tr>
              <td className="align-top py-1 text-body text-nowrap fw-bold">Project Id : </td>
              <td className="text-body-tertiary text-opacity-85 fw-semibold ps-3">{props.projectId}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AuditSummary;
